import { ServicesUseCase } from '../../../data/usecases'
import { makeAxiosHttpClient } from '../../factories'

type AssessmentModel = {
  id: string | number
}

export const createNewAssessment = () => {
  return new ServicesUseCase('/avaliacaoPsicologica', makeAxiosHttpClient())
}

export const fetchListToAssessment = (id?: number) => {
  return new ServicesUseCase(
    `/avaliacaoPsicologica/service/${id}`,
    makeAxiosHttpClient()
  )
}
export const getByIdAssessment = (id: string) => {
  return new ServicesUseCase(`/sessao/getSessao/${id}`, makeAxiosHttpClient())
}

export const updateAssessment = (id: string) => {
  return new ServicesUseCase(
    `/avaliacaoPsicologica/update/${id}`,
    makeAxiosHttpClient()
  )
}

export const deleteAssessment = ({ id }: AssessmentModel) => {
  return new ServicesUseCase(
    `/avaliacaoPsicologica/delete/${id}`,
    makeAxiosHttpClient()
  )
}
